import { HttpService } from './httpService';

export class NZBNService {
  public loading: boolean = false;

  constructor(
    private httpService: HttpService,
    private nzbnApiUrl: string,
    private nzbnApiToken: string
  ) {}

  public getNZBNEntity(
    nzbn: string,
    callback: (data: unknown) => void,
    errorCallback: (p: unknown) => void
  ): void {
    const url = '/entities/' + nzbn;

    this.nzbnGetCore(url, callback, errorCallback);
  }

  public searchNZBNEntities(searchTerm: string, callback: (data: unknown) => void): void {
    const url = '/entities/?search-term=' + searchTerm;

    this.nzbnGetCore(url, callback, () => {});
  }

  private nzbnGetCore(
    url: string,
    callback: (data: unknown) => void,
    errorCallback: (data: unknown) => void
  ): void {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.nzbnApiToken,
    };

    void this.httpService.get(this.nzbnApiUrl + url, headers, callback, errorCallback);
  }
}
